import { getSports } from '../../data/sports';
import { Ibreadcrumb } from '../../interfaces';

interface MsjProps {
    contents?: Ibreadcrumb[];
    color?: string;
    classItems?: string;
    classActive?: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function Breadcrumb(props: MsjProps): JSX.Element {
    const { contents, color, classItems, classActive } = props;
    const sport = getSports();
    const breads = [
        { key: 'home', name: 'Home', url: '/', add: false },
        {
            key: sport.key,
            name: sport.name,
            url: sport.url,
            add: false,
        },
    ];

    Array.prototype.push.apply(breads, contents);

    const allBreads = breads.map((b) => {
        return {
            key: b.key,
            name: b.name,
            url: b.add ? sport.url + b.url : b.url,
        };
    });
    //${color}
    return (
        <div className={`z-40 w-full fixed left-0 top-0 pt-24 pb-4 hidden sm:block ${color}`}>
            <div className="container mx-auto w-full flex-none md:flex">
                <div className="relative flex items-center justify-between h-4 w-full">
                    <div className="flex items-center justify-center sm:items-stretch sm:justify-start">
                        <nav className={`text-sm-blue-primary font-bold ${classActive}`} aria-label="Breadcrumb">
                            <ol className="list-none p-0 inline-flex">
                                {allBreads &&
                                    allBreads.length > 0 &&
                                    allBreads.map((content, index) => {
                                        return index == allBreads.length - 1 ? (
                                            <li className="flex items-center " key={index}>
                                                <a href={content.url} className={`text-gray-400 ${classItems}`}>
                                                    {content.name}
                                                </a>
                                            </li>
                                        ) : (
                                            <li className="flex items-center" key={index}>
                                                <a href={content.url}>{content.name}</a>
                                                <svg
                                                    className="fill-current w-3 h-3 mx-3"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 320 512"
                                                >
                                                    <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" />
                                                </svg>
                                            </li>
                                        );
                                    })}
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    );
}
